module.exports = __webpack_public_path__ + "img/scene25.469b5f10.gif";